/* ===========================================================================
   The Rich Beard · armazón (trb-shell.js)
   Cabecera (sólida al bajar, mega menú, menú móvil), cambio de tema,
   buscador con búsqueda predictiva, carrito AJAX + cajón, popup del boletín
   y reveals genéricos. Port de Header.tsx, ThemeToggle.tsx,
   SearchOverlay.tsx, lib/cart.tsx, CartDrawer.tsx y NewsletterPopup.tsx.
   Vanilla, sin dependencias. Expone window.TRB.cart.
=========================================================================== */
(function () {
  'use strict';
  if (window.__trbShell) return;
  window.__trbShell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfg = window.TRB || {};
  window.TRB = cfg;
  var doc = document;
  var html = doc.documentElement;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
      .replace(/<[^>]+>/g, '');
  }
  function lock(on) { doc.body.classList.toggle('trb-lock', !!on); }
  function anyOpen() { return !!$('.trb-so.is-open, .trb-cd.is-open, .trb-mnav.is-open'); }

  /* --- Diálogo genérico: abrir / cerrar / foco / Escape ------------------ */
  function dialog(el, opts) {
    var opener = null;
    var api = {
      open: function (from) {
        if (!el || el.classList.contains('is-open')) return;
        opener = from || doc.activeElement;
        el.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');
        lock(true);
        $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        setTimeout(function () {
          var f = opts && opts.focus ? $(opts.focus, el) : $(FOCUSABLE, el);
          if (f) f.focus({ preventScroll: true });
        }, 60);
        if (opts && opts.onOpen) opts.onOpen();
      },
      close: function () {
        if (!el || !el.classList.contains('is-open')) return;
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!anyOpen()) lock(false);
        if (opener && opener.focus) opener.focus({ preventScroll: true });
        opener = null;
        if (opts && opts.onClose) opts.onClose();
      },
      isOpen: function () { return !!el && el.classList.contains('is-open'); },
      el: el
    };
    if (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var items = $$(FOCUSABLE, el).filter(function (n) { return n.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    return api;
  }

  /* --- Tema claro / oscuro ----------------------------------------------- */
  function syncThemeButtons() {
    var light = html.dataset.theme === 'light';
    $$('[data-trb-theme]').forEach(function (b) {
      b.setAttribute('aria-label', light ? 'Switch to dark theme' : 'Switch to light theme');
      b.setAttribute('title', light ? 'Dark theme' : 'Light theme');
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-trb-theme]');
    if (!b) return;
    var next = html.dataset.theme === 'light' ? 'dark' : 'light';
    html.dataset.theme = next;
    try { localStorage.setItem('trb.mode', next); } catch (err) { /* sin almacenamiento */ }
    syncThemeButtons();
  });
  syncThemeButtons();

  /* --- Cabecera ----------------------------------------------------------- */
  var header = $('[data-trb-header]');
  function onScroll() { if (header) header.classList.toggle('is-solid', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var megaOpen = null;
  function setMega(id) {
    if (!header) return;
    $$('.trb-mega', header).forEach(function (m) { m.classList.toggle('is-open', !!id && m.getAttribute('data-trb-mega') === id); });
    megaOpen = id || null;
  }
  if (header) {
    $$('[data-trb-mega-trigger]', header).forEach(function (a) {
      a.addEventListener('mouseenter', function () { setMega(a.getAttribute('data-trb-mega-trigger')); });
      a.addEventListener('focus', function () { setMega(a.getAttribute('data-trb-mega-trigger')); });
    });
    $$('.trb-mega', header).forEach(function (m) {
      m.addEventListener('mouseenter', function () { setMega(m.getAttribute('data-trb-mega')); });
    });
    header.addEventListener('mouseleave', function () { setMega(null); });
    header.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) setMega(null); });
  }

  /* --- Menú móvil --------------------------------------------------------- */
  var mnav = dialog($('[data-trb-mnav]'));
  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-trb-mnav-open]')) { mnav.open(e.target.closest('[data-trb-mnav-open]')); return; }
    if (e.target.closest('[data-trb-mnav-close]')) { mnav.close(); }
  });

  /* --- Buscador ----------------------------------------------------------- */
  var srchEl = $('[data-trb-search]');
  var srch = dialog(srchEl, { focus: '[data-trb-search-input]', onOpen: function () { var i = srchEl && srchEl.querySelector('[data-trb-search-input]'); if (i && i.value.trim().length < 2) { srchSeq++; srchShow('idle'); } } });
  var srchInput = srchEl && $('[data-trb-search-input]', srchEl);
  var srchTimer = null, srchSeq = 0;

  function srchShow(state) {
    if (!srchEl) return;
    $('[data-trb-search-idle]', srchEl).hidden = state !== 'idle';
    $('[data-trb-search-none]', srchEl).hidden = state !== 'none';
    $('[data-trb-search-results]', srchEl).hidden = state !== 'results';
  }
  function srchGo() {
    var q = srchInput ? srchInput.value.trim() : '';
    if (!q) return;
    window.location.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shortTitle(t) { return String(t).split('–')[0].trim(); }
  /* Relevancia de lib/search.ts: pesa título > tipo > etiqueta > cuerpo,
     descarta las etiquetas genéricas y exige que TODOS los términos aparezcan.
     La API predictiva de Shopify devuelve los candidatos; esto los ordena. */
  var JUNK = ['beard care', 'hair', "men's grooming kit", 'natural', 'fresh', 'great', 'collections', 'organic'];
  var W = { titleExact: 100, titleStart: 60, titleWord: 30, type: 12, tag: 6, body: 3 };
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s]/g, ' '); }
  function rank(q, products) {
    var query = norm(q).trim();
    var terms = query.split(/\s+/).filter(function (t) { return t.length > 1; });
    if (!terms.length) return [];
    var hits = [];
    products.forEach(function (p) {
      var title = norm(p.title), type = norm(p.type || p.product_type), body = norm(p.body).slice(0, 900);
      var tags = (p.tags || []).map(norm).filter(function (t) { return JUNK.indexOf(t.trim()) === -1; });
      var score = 0, matched = 0;
      if (title === query) score += W.titleExact;
      if (title.indexOf(query) === 0) score += W.titleStart;
      terms.forEach(function (t) {
        var hit = false;
        if (new RegExp('\\b' + t).test(title)) { score += W.titleWord; hit = true; }
        if (type.indexOf(t) !== -1) { score += W.type; hit = true; }
        if (tags.some(function (tag) { return tag.indexOf(t) !== -1; })) { score += W.tag; hit = true; }
        if (body.indexOf(t) !== -1) { score += W.body; hit = true; }
        if (hit) matched++;
      });
      if (matched < terms.length || score === 0) return;
      hits.push({ p: p, score: score, price: parseFloat(p.price) || 0 });
    });
    return hits.sort(function (a, b) { return b.score - a.score || a.price - b.price; }).map(function (h) { return h.p; });
  }
  function srchRender(q, data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var cols = (data.resources && data.resources.results && data.resources.results.collections) || [];
    products = rank(q, products).slice(0, 6);
    $$('[data-trb-search-q]', srchEl).forEach(function (n) { n.textContent = q; });
    if (!products.length) { srchShow('none'); return; }
    var ul = $('[data-trb-search-products]', srchEl);
    ul.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2') : '';
      var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
      return '<li><a href="' + esc(p.url) + '" class="trb-so__item">' +
        '<div class="trb-card-media trb-so__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</div>' +
        '<span class="trb-so__txt"><span class="trb-so__t">' + esc(shortTitle(p.title)) + '</span><span class="trb-so__k">' + esc(p.type || '') + '</span></span>' +
        '<span class="trb-so__price trb-tnum">' + esc(price) + '</span></a></li>';
    }).join('');
    var wrap = $('[data-trb-search-catwrap]', srchEl);
    var lc = norm(q).trim();
    cols = cols.filter(function (c) { return norm(c.title).indexOf(lc) !== -1; }).slice(0, 3);
    wrap.hidden = !cols.length;
    $('[data-trb-search-cats]', srchEl).innerHTML = cols.map(function (c) {
      return '<li><a href="' + esc(c.url) + '" class="trb-link-u">' + esc(c.title) + '</a></li>';
    }).join('');
    srchShow('results');
  }
  function srchQuery() {
    var q = srchInput.value.trim();
    if (q.length < 2) { srchSeq++; srchShow('idle'); return; }
    var seq = ++srchSeq;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (seq === srchSeq) srchRender(q, data); })
      .catch(function () { if (seq === srchSeq) srchShow('none'); });
  }
  if (srchEl) {
    srchInput.addEventListener('input', function () {
      clearTimeout(srchTimer);
      srchTimer = setTimeout(srchQuery, 160);
    });
    $('[data-trb-search-form]', srchEl).addEventListener('submit', function (e) { e.preventDefault(); srchGo(); });
    srchEl.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-trb-search-chip]');
      if (chip) { srchInput.value = chip.getAttribute('data-trb-search-chip'); srchInput.focus(); srchQuery(); return; }
      if (e.target.closest('[data-trb-search-submit]')) { srchGo(); return; }
      if (e.target.closest('[data-trb-search-close]')) { srch.close(); }
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-trb-search-open]');
    if (!b) return;
    e.preventDefault();
    if (mnav.isOpen()) mnav.close();
    srch.open(b);
  });

  /* --- Carrito ------------------------------------------------------------ */
  var drawerEl = $('[data-trb-drawer]');
  var drawer = dialog(drawerEl, { focus: '[data-trb-drawer-close]' });
  var SECTION = 'trb-cart-drawer';

  function paintDrawer(sectionHtml) {
    if (!drawerEl || !sectionHtml) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = sectionHtml;
    var fresh = tmp.querySelector('[data-trb-cart-aside]');
    var cur = $('[data-trb-cart-aside]', drawerEl);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var fresco = tmp.querySelector('[data-trb-drawer]');
    if (fresco) drawerEl.setAttribute('data-count', fresco.getAttribute('data-count') || '0');
  }
  function setCount(n) {
    $$('[data-trb-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = !n;
      b.classList.remove('trb-cart-bump');
      void b.offsetWidth;
      if (n) b.classList.add('trb-cart-bump');
    });
    $$('[data-trb-cart-open]').forEach(function (b) { b.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  function afterCart(cart) {
    setCount(cart.item_count);
    doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }
  function request(path, body) {
    if (drawerEl) drawerEl.setAttribute('aria-busy', 'true');
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(root + path + '?skip_sync=1', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        paintDrawer(res.sections && res.sections[SECTION]);
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { afterCart(cart); return cart; })
      .finally(function () { if (drawerEl) drawerEl.removeAttribute('aria-busy'); });
  }
  function fail(err) {
    var msg = (err && (err.description || err.message)) || 'Could not update the cart. Please try again.';
    if (window.showToast) window.showToast(msg); else window.alert(msg);
  }
  var cartApi = {
    add: function (items, opts) {
      var list = Array.isArray(items) ? items : [items];
      return request('cart/add.js', { items: list }).then(function (cart) {
        if (!opts || opts.open !== false) drawer.open(opts && opts.from);
        return cart;
      }).catch(fail);
    },
    change: function (key, qty) {
      return request('cart/change.js', { id: key, quantity: qty }).catch(fail);
    },
    refresh: function () {
      return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { paintDrawer(j[SECTION]); })
        .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); return cart; });
    },
    open: function (from) { drawer.open(from); },
    close: function () { drawer.close(); }
  };
  cfg.cart = cartApi;
  /* Compatibilidad con trb-ficha.js y trb-carrito.js */
  window.refreshCartDrawer = function (open) { return cartApi.refresh().then(function () { if (open) drawer.open(); }); };
  window.updateCartBadges = function () { fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }); };

  doc.addEventListener('click', function (e) {
    var open = e.target.closest('[data-trb-cart-open]');
    if (open) { e.preventDefault(); drawer.open(open); return; }
    if (e.target.closest('[data-trb-drawer-close]')) { drawer.close(); return; }
    var add = e.target.closest('[data-trb-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');
      cartApi.add({ id: parseInt(add.getAttribute('data-trb-add'), 10), quantity: parseInt(add.getAttribute('data-trb-qty') || '1', 10) }, { from: add })
        .then(function () { add.disabled = false; add.removeAttribute('aria-busy'); });
      return;
    }
    var q = e.target.closest('[data-trb-qty]');
    if (q && drawerEl && drawerEl.contains(q)) {
      e.preventDefault();
      cartApi.change(q.getAttribute('data-trb-qty'), parseInt(q.getAttribute('data-qty'), 10));
    }
  });
  doc.addEventListener('cart:updated', function (e) {
    /* Cambios hechos desde la página /cart: el cajón se repinta por si se abre después. */
    if (e.detail && e.detail.cart && !drawerEl.hasAttribute('aria-busy') && !drawer.isOpen()) {
      setCount(e.detail.cart.item_count);
    }
  });
  var cartParam = /[?&]cart=open/.test(window.location.search);
  if (cartParam) drawer.open();

  /* --- Escape cierra lo que esté abierto ---------------------------------- */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (srch.isOpen()) srch.close();
    else if (drawer.isOpen()) drawer.close();
    else if (mnav.isOpen()) mnav.close();
    else if (popEl && popEl.classList.contains('is-open')) popClose();
    setMega(null);
  });

  /* --- Popup del boletín -------------------------------------------------- */
  var popEl = $('[data-trb-pop]');
  /* La barra de vista previa de Shopify (solo en preview) tapa lo fijo abajo.
     Se mide y se publica como --trb-pbar; sin barra queda en 0. */
  function medirPbar() {
    var b = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    var h = 0;
    if (b) { var r = b.getBoundingClientRect(); if (r.height && r.top < window.innerHeight) h = Math.max(0, Math.round(window.innerHeight - r.top)); }
    document.documentElement.style.setProperty('--trb-pbar', h + 'px');
  }
  medirPbar(); window.addEventListener('resize', medirPbar); setTimeout(medirPbar, 1500); setTimeout(medirPbar, 4000);
  var bubble = $('[data-trb-pop-bubble]');
  function popClose() {
    if (!popEl) return;
    popEl.classList.add('is-closing');
    setTimeout(function () {
      popEl.classList.remove('is-open', 'is-closing');
      popEl.setAttribute('aria-hidden', 'true');
      if (bubble && !leerPop('trb.popup.subscribed')) { bubble.hidden = false; bubble.classList.add('is-open'); }
    }, 260);
  }
  function popOpen() {
    if (!popEl) return;
    if (bubble) { bubble.classList.remove('is-open'); bubble.hidden = true; }
    popEl.classList.remove('is-closing');
    popEl.classList.add('is-open');
    popEl.setAttribute('aria-hidden', 'false');
  }
  /* Chad (6 oct): la burbuja queda fija abajo en todas las páginas y visitas
     hasta que el visitante deja su correo. El estado vive en localStorage. */
  function leerPop(k) { try { return localStorage.getItem(k) === '1'; } catch (err) { return false; } }
  function guardarPop(k) { try { localStorage.setItem(k, '1'); } catch (err) { /* ignorar */ } }
  if (popEl) {
    var excluded = (popEl.getAttribute('data-exclude') || '').split(',').some(function (p) { return p && window.location.pathname.indexOf(p) === 0; });
    var seen = leerPop('trb.popup.seen');
    var suscrito = leerPop('trb.popup.subscribed');
    if (!excluded && seen && !suscrito && bubble && !html.classList.contains('shopify-design-mode')) {
      bubble.hidden = false; bubble.classList.add('is-open');
    }
    if (!excluded && !seen && !suscrito && !html.classList.contains('shopify-design-mode')) {
      var done = false;
      var fire = function () {
        if (done) return;
        done = true;
        popOpen();
        guardarPop('trb.popup.seen');
        window.removeEventListener('scroll', onPopScroll);
      };
      var pct = parseInt(popEl.getAttribute('data-scroll'), 10) / 100 || 0.4;
      var onPopScroll = function () {
        var max = doc.body.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max > pct) fire();
      };
      setTimeout(fire, parseInt(popEl.getAttribute('data-delay'), 10) || 18000);
      window.addEventListener('scroll', onPopScroll, { passive: true });
    }
    doc.addEventListener('click', function (e) {
      if (e.target.closest('[data-trb-pop-close]')) { popClose(); return; }
      if (e.target.closest('[data-trb-pop-bubble]')) { popOpen(); }
    });
    var form = $('[data-trb-pop-form]', popEl);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = $('input[type=email]', form).value;
        if (email.indexOf('@') === -1) return;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).catch(function () { /* el acuse se muestra igual */ });
        $('[data-trb-pop-row]', form).hidden = true;
        $('[data-trb-pop-ok]', form).hidden = false;
        guardarPop('trb.popup.subscribed');
        setTimeout(function () {
          popClose();
          setTimeout(function () { if (bubble) { bubble.classList.remove('is-open'); bubble.hidden = true; } }, 300);
        }, 2600);
      });
    }
  }

  /* --- Reveal genérico ---------------------------------------------------- */
  var rev = $$('.trb-reveal-up, .trb-reveal-left, .trb-reveal-scale');
  if (rev.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    rev.forEach(function (n) { io.observe(n); });
  } else { rev.forEach(function (n) { n.classList.add('is-in'); }); }

  /* --- Editor de temas: abrir el cajón o el popup al seleccionarlos ------- */
  doc.addEventListener('shopify:section:select', function (e) {
    var t = e.target;
    if (t && t.querySelector('[data-trb-drawer]')) drawer.open();
    if (t && t.querySelector('[data-trb-pop]')) popOpen();
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var t = e.target;
    if (t && t.querySelector('[data-trb-drawer]')) drawer.close();
    if (t && t.querySelector('[data-trb-pop]')) popClose();
  });
})();
